import React from 'react';
import { Button } from 'react-bootstrap';
import { BadgeWithTooltip } from '../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';
import { ConfirmModal } from '../../../ui/ConfirmModal/ConfirmModal';
import { gamePassAchievementTooltipContent } from '../AchievementRow/AchievementRowGamePass';
import { useGamePassActions } from './useGamePassActions';

type AchievementsModalGamePassProps = {
  disabled?: boolean,
};

export function AchievementsModalGamePass({ disabled }: AchievementsModalGamePassProps) {
  const {
    isGamePassAchievementExisting,
    isBusy,
    showDiscardConfirmation,
    handleClick,
    handleConfirm,
    handleCancel,
  } = useGamePassActions();

  const buttonLabel = isGamePassAchievementExisting ? '+ Add GamePass' : 'Backfill GamePass';

  return (
    <div className="ml-3">
      <Button
        size="sm"
        variant="secondary"
        onClick={handleClick}
        title="Add GamePass feature"
        disabled={isBusy || disabled}
        className="d-flex align-items-center"
      >
        {buttonLabel}
        <BadgeWithTooltip
          id="gamepass-button"
          title="GamePass Achievement"
          content={gamePassAchievementTooltipContent()}
          variant="primary"
          className="ml-2"
        />
      </Button>
      <ConfirmModal
        centered
        show={showDiscardConfirmation}
        isLoading={false}
        title="Unsaved Achievements Confirmation"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        className="overlay"
        backdrop="static"
      >
        <div className="text-center">
          You have unsaved Achievements changes.
          <br />
          Are you sure you want to discard them?
        </div>
      </ConfirmModal>
    </div>
  );
}
